import React, { useState, useEffect, useRef } from 'react';
import TopCard from './TopCard';
import BottomCard from './BottomCard';
import AddButton from './AddButton';
import ButtonEditor from './ButtonEditor';
import TopCardEditor from './TopCardEditor';
import ProfilePicEditor from './ProfilePicEditor';
import { Link } from 'react-router';
import Fade from 'react-bootstrap/Fade';
import jobsAPI from '../../../utils/API/jobsAPI';
import { AnimatePresence, motion } from 'motion/react';
import { useAuth } from '../../../utils/Auth';
import styles from './VCard.module.css';
import { useThemes } from '../../../utils/customHooks';

export default function Vcard(props) {
    const { showForm, setShowForm } = props;
    const { userObj, vcardObj } = useAuth();
    const themes = useThemes(userObj);
    const { uid, account_type, jobs, enterprise, permissions } = userObj;
    const { profile_theme, buttons, profile_pic, skills, show_resume, resume_link } = vcardObj;

    const [ buttonsState, setButtonsState ] = useState(buttons);
    const [ buttonToEdit, setButtonToEdit ] = useState();
    const [ skillsArr, setSkillsArr ] = useState([]);
    const [ open, setOpen ] = useState(false);

    const menuRef = useRef();
    
    useEffect(() => {
        const handleGetSkills = async () => {
            await jobsAPI.getSkills().then(res => setSkillsArr(res?.data ? res.data : []));
        };

        if (skills) {
            handleGetSkills();
        };
    },[skills]);


    const handleDynamicReturn = () => {
        switch(showForm) {
            case "edit-button":
                return(
                    <motion.div key='button-editor' initial={{scale: .2, opacity: 0, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} animate={{scale: 1, opacity: 1, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} exit={{ scale: 0, opacity: 0, transition: { duration: 1, ease: [.56, .03, .12, 1.04]}}} >
                        <ButtonEditor
                            uid={uid}
                            accountType={account_type}
                            setShowForm={setShowForm}
                            buttons={buttonsState}
                            setButtons={setButtonsState}
                            buttonToEdit={buttonToEdit}
                            permissions={permissions}
                            setButtonToEdit={setButtonToEdit}
                            profile_theme={profile_theme}
                        />
                    </motion.div>
                );
            case "edit-top-card":
                return(
                    <motion.div key="top-card-editor" initial={{scale: .2, opacity: 0, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} animate={{scale: 1, opacity: 1, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} exit={{scale: 0, opacity: 0, transition: { duration: 1, ease: [.56, .03, .12, 1.04]}}}>
                        <TopCardEditor
                            uid={uid}
                            vcardObj={vcardObj}
                            permissions={permissions}
                            setShowForm={setShowForm}
                            enterprise={enterprise}
                            skillsArr={skillsArr}
                            setSkillsArr={setSkillsArr}
                            jobs={jobs}
                        />
                    </motion.div>
                );
            case "edit-profile-image":
                return(
                    <motion.div key="profile-image" initial={{scale: .2, opacity: 0, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} animate={{scale: 1, opacity: 1, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} exit={{scale: 0, opacity: 0, transition: { duration: 1, ease: [.56, .03, .12, 1.04]}}}>
                        <ProfilePicEditor
                            setShowForm={setShowForm}
                            profile_pic={profile_pic}
                            uid={uid}
                        />
                    </motion.div>
                );
            case "add-button":
                return(
                    <motion.div key="add-button" initial={{scale: .2, opacity: 0, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} animate={{scale: 1, opacity: 1, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} exit={{scale: 0, opacity: 0, transition: { duration: 1, ease: [.56, .03, .12, 1.04]}}}>
                        <AddButton 
                            uid={uid}
                            setShowForm={setShowForm}
                            buttons={buttonsState}
                            setButtonState={setButtonsState}
                            accountType={account_type}
                            permissions={permissions}
                            profile_theme={profile_theme}
                        />
                    </motion.div>
                );
            default:
                if (!profile_pic && !profile_theme.background) {
                    return (
                        <div className='settings-loader-wrap'>
                            <div className='settings-loader'></div>
                        </div>
                    );
                } else if (profile_theme) {
                    return (
                        <motion.div key="vcard" initial={{scale: .2, opacity: 0, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} animate={{scale: 1, opacity: 1, transition: {duration: 1, ease: [.56, .03, .12, 1.04]}}} exit={{scale: 0, opacity: 0, transition: { duration: 1, ease: [.56, .03, .12, 1.04]}}}>
                            <div className={styles.vcardContainer} style={{background: profile_theme.main_background}}>
                                <TopCard
                                    uid={uid}
                                    vcardObj={vcardObj}
                                    profile_theme={profile_theme}
                                    setShowForm={setShowForm}
                                    themes={themes}
                                    permissions={permissions}
                                    skillsArr={skillsArr}
                                    jobs={jobs}
                                    show_resume={show_resume}
                                    resume_link={resume_link}
                                />
                                <BottomCard
                                    accountType={account_type}
                                    profile_theme={profile_theme}
                                    messaging={vcardObj.messaging}
                                    buttons={buttons}
                                    buttonsState={buttonsState}
                                    setButtonsState={setButtonsState}
                                    setButtonToEdit={setButtonToEdit}
                                    setShowForm={setShowForm}
                                    permissions={permissions}
                                    uid={uid}
                                />
                            </div>
                        </motion.div>
                    );
                } else {
                    return (<></>);
                };
    
        };
    };

    useEffect(() => {
        const menu = menuRef.current;
        const handleClickOutside = e => {
            if (menu && !menu.contains(e.target)) {
                setOpen(false);
            };
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    },[]);


    return (
        <div className={styles.wrapper}>
            <div className={styles.top}>
                <div className={styles.header}>
                    Digital Business Card
                    <span>Get Creative!</span>
                </div>
                <div className={styles.topInner}>
                    {permissions.edit_profile_theme && <Link to='/settings/themes' className={styles.link}>Edit Designs</Link>}
                    <button className={styles.vcardMenuBtn} onClick={() => setOpen(!open)}><i className='fas fa-ellipsis-vertical' /></button>
                    <Fade in={open} style={open ? {display: 'flex'} : {display: 'none'}} >
                        <div className={styles.vcardMenuPosition} ref={menuRef}>
                            <div className={styles.vcardMenu}>
                                {permissions.edit_profile_theme && <Link to='/settings/themes' className={`${styles.link992} ${styles.vcardMenuOption}`}>Edit Designs</Link>}
                                <button className={styles.vcardMenuOption} onClick={() => {setShowForm('edit-top-card'); setOpen(false);}}>Edit Top Card</button>
                                <button className={styles.vcardMenuOption} onClick={() => {setShowForm('edit-profile-image'); setOpen(false);}}>Edit Profile Image</button>
                                <button className={styles.vcardMenuOption} onClick={() => {setShowForm('add-button'); setOpen(false);}}>Add Button</button>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
            <div className={styles.container}>
                <AnimatePresence mode='popLayout' initial={false}>
                    {handleDynamicReturn()}
                </AnimatePresence>
            </div>
        </div>
    );
};